$.cachedScript = function( url, options ) {

  // Allow user to set any option except for dataType, cache, and url
  options = $.extend( options || {}, {
    dataType: "script",
    cache: true,
    url: url
  });

  // Use $.ajax() since it is more flexible than $.getScript
  // Return the jqXHR object so we can chain callbacks
  return $.ajax( options );
};

$.loadCss = function( url, id, success, fail ) {

  var i,
      sheet,
      checkTimer,
      onReadyStateChange,
      ticks = 0,
      link =  $('#'+id);


  if (link.length === 0) {
    link = document.createElement("link");
  }else{
    link = link.get(0);
  }

  link.setAttribute("rel", "stylesheet");
  link.setAttribute("type", "text/css");
  link.setAttribute("id", id);
  link.setAttribute("href", url);

  onReadyStateChange = function() {
    if (success && typeof(success) === 'function') {
      success();
    }
  };

  checkTimer = function () {

    for (i = 0; i < document.styleSheets.length; i++) {
      sheet = document.styleSheets[i].href;
      if (sheet !== null && sheet.substr(sheet.length - url.length) == url) {
        return onReadyStateChange();
      }
    }

    if (ticks < 200) {
      setTimeout(checkTimer, 50);
      ticks++;
    }else{
      if (fail && typeof(fail) === 'function') {
        fail();
      }
    }
  };

  if (document.all) { //Uses onreadystatechange for Internet Explorer
    link.attachEvent('onreadystatechange', function () {
      if (link.readyState == 'complete' || link.readyState == 'loaded'){
        onReadyStateChange();
      }
    });
  } else {    //Checks if the stylesheet has been loaded every 50 ms for others
    setTimeout(checkTimer, 50);
  }

  $('head:first').append(link);

};

if (!window.console ||
    (window.console && typeof(window.console.log) !== 'function')) {
  window.console = {
    log: function() {},
    warn: function() {}
  };
}